import { apiClient } from '@/lib/api'

// --- AI Instructions ---

export interface AIInstruction {
  id: string
  content: string
  is_active: boolean
  sort_order: number
  created_at: string
  updated_at: string
}

export interface AIInstructionCreate {
  content: string
  is_active?: boolean
  sort_order?: number
}

export interface AIInstructionUpdate {
  content?: string
  is_active?: boolean
  sort_order?: number
}

export const aiInstructionsApi = {
  list: () => apiClient.get<AIInstruction[]>('/ai-instructions/'),

  create: (data: AIInstructionCreate) =>
    apiClient.post<AIInstruction>('/ai-instructions/', data),

  update: (id: string, data: AIInstructionUpdate) =>
    apiClient.put<AIInstruction>(`/ai-instructions/${id}`, data),

  delete: (id: string) =>
    apiClient.delete<void>(`/ai-instructions/${id}`),

  reorder: (items: { id: string; sort_order: number }[]) =>
    apiClient.patch<{ status: string }>('/ai-instructions/reorder', { items }),
}

// --- System Prompts ---

export interface SystemPrompt {
  prompt_key: string
  display_name: string
  description: string | null
  content: string
  default_content: string
  is_customized: boolean
  template_variables: string[]
  updated_at: string | null
  updated_by_id: string | null
}

export const systemPromptsApi = {
  list: () => apiClient.get<SystemPrompt[]>('/system-prompts/'),

  get: (key: string) =>
    apiClient.get<SystemPrompt>(`/system-prompts/${key}`),

  update: (key: string, content: string) =>
    apiClient.put<SystemPrompt>(`/system-prompts/${key}`, { content }),

  reset: (key: string) =>
    apiClient.post<SystemPrompt>(`/system-prompts/${key}/reset`),
}
